import * as Yup from 'yup';
export const initialHealthCareWorkerValues = {
    consentForPhoto: false,
    languageId: '',
    teamLeadId: '',
};
export const healthCareWorkerSchema = Yup.object().shape({
    consentForPhoto: Yup.bool(),
    languageId: Yup.string(),
    teamLeadId: Yup.string(),
});
//# sourceMappingURL=health-care-worker.js.map